/* eslint-disable react/require-default-props */
/* eslint-disable react/no-unused-prop-types */

import React, { forwardRef, Ref } from 'react';
import {
  MenuButton,
  MenuItem,
  Tooltip,
  makeStyles,
  mergeClasses,
} from '@fluentui/react-components';

import { NavItemProps } from './types';

const useStyles = makeStyles({
  button: {
    height: '48px',
    width: '48px',
    maxWidth: '48px',
  },
});

export const NavItem: React.FC<NavItemProps> = forwardRef<HTMLElement, NavItemProps>(({
  icon, text, onClick, as, className,
}, ref) => {
  const classes = useStyles();
  const Icon = icon;
  if (as === MenuButton) {
    return (
      <Tooltip content={text} relationship="label">
        <MenuButton
          className={mergeClasses(classes.button, className, 'nav-item')}
          icon={<Icon />}
          appearance="subtle"
          onClick={onClick}
          ref={ref as Ref<HTMLButtonElement>}
        />
      </Tooltip>
    );
  }

  if (as === MenuItem) {
    return (
      <MenuItem
        icon={<Icon />}
        onClick={onClick}
        className={mergeClasses(className, 'nav-menu-item')}
        ref={ref as Ref<HTMLDivElement>}
      >
        {text}
      </MenuItem>
    );
  }
  return null;
});
